/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Extra_Units_Inbound_FixedInputs */

const en_error_extra_units_inbound_fixed = /** @type {(inputs: Error_Extra_Units_Inbound_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The units of this inbound are already in the warehouse: its lines do not change and it cannot be cancelled. You can still change its header and documents.`)
};

/**
* | output |
* | --- |
* | "The units of this inbound are already in the warehouse: its lines do not change and it cannot be cancelled. You can still change its header and documents." |
*
* @param {Error_Extra_Units_Inbound_FixedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_extra_units_inbound_fixed = /** @type {((inputs?: Error_Extra_Units_Inbound_FixedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Extra_Units_Inbound_FixedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_extra_units_inbound_fixed(inputs)
});